import React from "react";
import styled from "styled-components";

export const BackgroundPanel = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  background-color: ${(props) => props.theme.colors.DARK_BACKGROUND};
  width: 100vw;
  height: 100vh;
  position: relative;
`;

export const BackgroundPanelMobile = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  width: 100vw;
  height: 100vh;
  background-color: ${(props) => props.theme.colors.TEXT_BACKGROUND};
  position: relative;
`;

export const CenterAlignmentWrapper = styled.main`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const RedirectWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.TEXT_BACKGROUND};
  width: 35rem;
  padding: 3rem;
  text-align: center;
  display: flex;
  flex-direction: column;
`;

export const RedirectMobilePanel = styled.div`
  margin: auto;
  padding: 3rem 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
`;

export const LogoWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 1rem;
`;

export const LogoImage = styled.img<React.ImgHTMLAttributes<HTMLImageElement>>`
  height: 4.2rem;
  width: auto;
`;

export const LoadingText = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
`;
